if (!customElements.get('steadia-shipping-protection')) {
  customElements.define('steadia-shipping-protection', class extends HTMLElement {
    async connectedCallback() {
      if (this.closest('cart-drawer') && window.SteadiaCart) {
        await customElements.whenDefined('cart-drawer');
        if (!this.isConnected) return;
        window.SteadiaCart.bindForm(this);
        const checkbox = this.querySelector('[data-protection-checkbox]');
        if (checkbox) {
          checkbox.disabled = false;
          this.classList.add('is-enhanced');
          checkbox.addEventListener('change', () => {
            // Remember an unticked free box so it is not added back.
            if (this.dataset.free === 'true') this.remember(checkbox.checked ? 'added' : 'declined');
            this.querySelector('form').requestSubmit();
          });
          // Shopify is the source of truth; restore the selection after a failed request.
          this.querySelector('form').addEventListener('submit', () => {
            this.onSelectionIdle = () => {
              if (this.isConnected) checkbox.checked = Boolean(this.dataset.line);
            };
            document.addEventListener('steadia:cart-idle', this.onSelectionIdle, { once: true });
          });
        }
        this.onIdle = (event) => {
          // Failed mutations leave the same markup in place. Retrying on every
          // idle event would loop indefinitely; let the shopper retry instead.
          if (event.detail?.success === false) return;
          this.normalizeDrawer();
          this.syncFree();
        };
        document.addEventListener('steadia:cart-idle', this.onIdle);
        this.normalizeDrawer();
        this.syncFree();
        return;
      }
      const line = this.dataset.line;
      this.querySelector('form')?.addEventListener('submit', (event) => {
        if (this.dataset.free === 'true') this.remember(line ? 'declined' : 'added');
        event.currentTarget.querySelector('button').disabled = true;
      });
      let state = null;
      try { state = sessionStorage.getItem('steadia:protection-free'); } catch {}
      const extra = this.extraLine();
      const free = this.dataset.free === 'true';
      const wrongKind = line && (free !== (this.dataset.lineFree === 'true'));
      // Full-page carts must enforce the same free offer as the drawer.
      // Remove a paid/free mismatch before adding anything, never auto-charge.
      const addFree = free && !line && state !== 'declined';
      if (extra || addFree || (line && (+this.dataset.bottles === 0 || +this.dataset.quantity !== 1 || wrongKind))) {
        const checkout = document.getElementById('checkout');
        if (checkout) checkout.disabled = true;
        const express = document.querySelector('.cart__dynamic-checkout-buttons');
        if (express) { express.hidden = true; express.setAttribute('inert', ''); }
        const quantity = extra || wrongKind || +this.dataset.bottles === 0 ? 0 : 1;
        fetch(addFree ? routes.cart_add_url : routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: addFree ? this.dataset.variant : extra || line, quantity: addFree ? 1 : quantity }),
        }).then(async (response) => {
          const result = await response.json();
          if (!response.ok || result.errors) throw new Error('Unable to update protection.');
          if (!free && this.dataset.lineFree === 'true') this.remember(null);
          window.location.reload();
        }).catch(() => {
          const error = this.querySelector('[data-protection-error]');
          error.textContent = 'Please remove Shipping Protection, then continue.';
          error.hidden = false;
        });
      }
    }
    disconnectedCallback() {
      if (this.onIdle) document.removeEventListener('steadia:cart-idle', this.onIdle);
      if (this.onSelectionIdle) document.removeEventListener('steadia:cart-idle', this.onSelectionIdle);
    }
    remember(value) {
      try {
        if (value) sessionStorage.setItem('steadia:protection-free', value);
        else sessionStorage.removeItem('steadia:protection-free');
      } catch {}
    }
    extraLine() {
      return (this.dataset.lines || '').split('|').find((key) => key && key !== this.dataset.line);
    }
    // The $0 protection is added once, swapped in for a paid one, and removed if the cart stops qualifying.
    async syncFree() {
      // The full cart owns normalization when both cart surfaces are mounted.
      // Otherwise the hidden drawer and main cart can each add a free line.
      if (document.querySelector('main steadia-shipping-protection')) return;
      if (!this.isConnected || window.SteadiaCart.busy) return;
      let state = null;
      try { state = sessionStorage.getItem('steadia:protection-free'); } catch {}
      const free = this.dataset.free === 'true';
      const line = this.dataset.line;
      const lineFree = this.dataset.lineFree === 'true';
      const needsUpdate = (!free && line && lineFree) || (free && line && !lineFree) || (free && !line && state !== 'declined');
      if (!needsUpdate) return;
      // Do not let checkout charge paid protection while the box promises it free.
      // A successful section render replaces this button; on failure it stays blocked.
      const checkout = this.closest('cart-drawer').querySelector('[name="checkout"]');
      if (checkout) checkout.disabled = true;
      if (!free && line && lineFree) {
        this.remember(null);
        await window.SteadiaCart.mutate(routes.cart_change_url, { id: line, quantity: 0 }, this);
      } else if (free && line && !lineFree) {
        this.remember('added');
        await window.SteadiaCart.mutate(routes.cart_change_url, { id: line, quantity: 0 }, this);
      } else if (free && !line && state !== 'declined') {
        this.remember('added');
        await window.SteadiaCart.mutate(routes.cart_add_url, { id: this.dataset.variant, quantity: 1 }, this);
      }
    }
    async normalizeDrawer() {
      if (document.querySelector('main steadia-shipping-protection')) return;
      if (!this.isConnected || this.normalizing || !this.dataset.line) return;
      const extra = this.extraLine();
      if (!extra && +this.dataset.bottles > 0 && +this.dataset.quantity === 1) return;
      const checkout = this.closest('cart-drawer').querySelector('[name="checkout"]');
      if (checkout) checkout.disabled = true;
      if (window.SteadiaCart.busy) return;
      this.normalizing = true;
      const result = await window.SteadiaCart.mutate(routes.cart_change_url, {
        id: extra || this.dataset.line,
        quantity: extra || +this.dataset.bottles === 0 ? 0 : 1,
      }, this);
      if (!result && this.isConnected) {
        const error = this.querySelector('[data-protection-error]');
        error.textContent = 'Please remove Shipping Protection, then continue.';
        error.hidden = false;
      }
    }
  });
}
